export default "__VITE_ASSET__hFlhX7HS__"